/* CHITA 埋点 · 主题侧事件 v1.0.21（v1.0.21：组合购 bundle_id 改为 page:页面网址最后一段(page handle)，与订单商品行 _bundle 属性一致，订单和 GA4 组合加购可对上号；只对组合购页面生效，组合购集合页不覆盖原有 bundle_id；运营改组合购页网址后新旧数据按新网址另记（Nora 11-02）；v1.0.20：组合购页终版改为选商品直接加进店铺购物车(/cart/add.js)、走普通结账：该页弹窗加购按 add_to_cart(cart_action=bundle_add，bundle_id=page:模板名) 记，每次加购记 1 次；不再在点结账时另记组合加购；小窗删除走 /cart/change，照常记 remove_from_cart（11-02 终版）；v1.0.19：组合购页选商品、组合加购补商品 ID(item_id，从弹窗 QuickAdd-<商品ID> 取)；从结账页返回后再点结账也记(不再看按钮 aria-disabled，改为 2 秒内重复点只记 1 次)（J2 11-02 代码审查）；v1.0.18：组合购页(页面模板名含 bundle，如 page.bundles-1027)按组合购页记：page_type=bundles，选商品记 bundle_item_select，点结账记 1 次组合加购 add_to_cart(cart_action=bundle_add)——该页用自建小购物车、结账直接跳 /cart/变体:数量，原加购拦截抓不到（11-02）；v1.0.17：v1.0.17：黑五落地页(页面模板名含 black-friday，如 page.black-friday-2 / black-friday-members)也按黑五页记活动位曝光点击，横幅/图文按钮自动识别，运营不用加标记（燕妮 10-30 20:10）；v1.0.16：加购后的校准不再用旧购物车 / 错误返回覆盖快照，加购在共用快照上累加（购物车页重复补发加购，Kevin 10-30 08:45）；v1.0.15：直发补上 gtag 同款设备提示参数，同一台设备的事件不再被 GA4 分成「手机」「平板」两类（J2 10-30）；停留时长改为累计——顾客切走再切回来的时间也算，每次切走 / 离开补报这一段（≥1 秒），分析时按页面加总 dwell_seconds（燕妮 10-30 拍板）；v1.0.14：精选集合 / Shop the look 列表名带区块标题，不再撞名（B-BUG4）；v1.0.13：10-29 夜间对抗测试修复——第一次取购物车排进队列、取失败用快照当基准（页面刚打开就删除会丢，A-BUG3/4）；加购直接按加购接口返回记（加购后马上跳页/刷新/关页会丢，A-BUG2）；购物车快照改存所有标签共用的 localStorage、30 分钟有效，切回标签页时悄悄校准（两个标签页漏记/重复记，A-BUG5/6）；点侧栏关闭 X 不再算操作购物车（A-BUG1）；fetch 传 URL 对象也拦（A-BUG7）；同名 GA 会话 cookie 多个时取最新（A-BUG8）；100 字截断按字符算（半个 emoji 让整条发送失败，J-T1）；未标记列表用区块标题命名、ID 统一小写下划线（B-BUG1）；首页轮播 data-chita-shown-ms / shown-at 显示时长补记曝光（G-BUG4）；v1.0.12：v1.0.12：直发改为优先 sendBeacon，失败再 fetch keepalive（iPhone Safari 同页连发加购/看购物车只到第 1 条）；v1.0.11：标记式活动位的点击只算点在链接上（容器本身不是链接时，点标题、描述文字不再记 select_promotion——Chosen，Jennifer2 10-28 回归）；首屏活动位补记脚本加载前已显示的时间：慢网下脚本约 7 秒才运行，Hero 第一张 6 秒就切走，1 秒计时等不满会漏记（Jennifer2 10-28 回归，4G 复现）——页面没滚动、轮播还没切过（.is-run）时，按首次绘制起算；v1.0.10：带 data-chita-list 的列表，卡片要连续可见 0.5 秒才记曝光（切标签时正在淡出的旧卡不再被记）；还没显示出来的卡每 0.7 秒再判断一次（首页卡片淡入用 Web Animations，结束时没有任何事件：首屏卡要等到别的页面变化才记，手机上切标签后新标签的卡会漏记——Jennifer2 10-28 实测）；v1.0.9：v1.0.9：首页 Live With 卡片视频 video_start / video_progress(50%) / video_complete（data-chita-video 标记；每个视频每页：自动播放 1 次 + 顾客主动 1 次（点击或取消静音，先到先记），50% 和播完各 1 次）；点视频播放 / 静音按钮（data-chita-video-control）不算点商品、点活动位；新版 CHITA 页头根节点不是 <header>，页头搜索联想里的商品按 .ch-header 排除，不算列表曝光 / 点击；v1.0.8：v1.0.8：活动位曝光的 1 秒计时不再被页面变化重置（首页持续动画每秒上百次 class/style 变化，计时永远等不满，曝光随机丢——首页同学 10-27 定位）；淡入动画结束后也重新判断一次（CSS 动画不改属性，进入视口时透明度为 0 会漏）；v1.0.7：v1.0.7：page_dwell、web_vitals 也改为直发——两者都在页面隐藏 / 离开时触发，交给 gtag 攒批会和加购一样丢；v1.0.6：加购、删除、看购物车、点击、筛选排序这类「点完就可能跳走」的事件不再交给 gtag 攒批，直接用 fetch keepalive 发到同一个测量 ID（client_id / session_id 读 GA Cookie，与 gtag 一致；读不到或会话已过期时仍走 gtag），每条只走一条路（Jennifer2 10-27 实测：加购后几秒内离开页面，gtag 攒着的 add_to_cart 会丢）；v1.0.4：自己加载 gtag（独立 chitaDataLayer，不依赖、不影响店铺 GTM），config 测量 ID 且不发 page_view，首页也初始化以便像素读到 _ga_<ID> 会话 Cookie；v1.0.3：带 data-chita-list 的列表，隐藏的标签 / 轮播里的商品不算曝光（H-09b）；首页埋点——新版首页带 data-chita-module 标记时才启用，旧首页不发任何事件；data-chita-list 列表名/ID、data-chita-promo 活动位（全站通用，轮播只算当前显示的一张）；v1.0.2：曝光不再逐个请求 /products/x.js 换 ID（抽屉一开就几十次，会把顾客 IP 打到限流），取不到数字 ID 时报 handle 并带 item_handle，入库时按商品表换 ID；改数量/删除直接用接口返回的购物车，不再额外请求 /cart.js；v1.0.1：组合加购 bundle_id 统一为组合商品 ID，选择码放 bundle_selection；v1.0：组合购自选页选子商品 bundle_item_select、组合加购带子商品、/cart.js 取不到时按加购请求补发、黑五活动位 item_id 转数字；Jennifer 接手：字段名/取值对齐字典 v0.4，商品 ID 读卡片属性）（浏览/加购/购物车在主题；page_view、结账 5 步、purchase 在客户事件像素）
 * 覆盖：列表曝光与点击、筛选排序、商品浏览/变体/停留、加购/改数量/删除（组合加购只计 1 次）、购物车/侧边购物车查看、滚动深度、JS 报错、首页活动位与商品模块（按 data-* 标记，规范见《首页埋点规范》）；结账与订单走 Shopify 像素/店铺数据，不在这里。
 * 输出：window.chitaEvents（全部事件）；不往 dataLayer 推，避免触发现有 GTM
 *       + 配置了 CHITA_CTX.ga4_id 时用自己的 gtag 直接发 GA4（为空不加载、不发）。
 * 调试：?chita_debug=1 打开（右下角显示事件窗口，事件带 debug_mode / traffic_type=internal），?chita_debug=0 关闭。
 */
(function () {
  'use strict';
  var CTX = window.CHITA_CTX || {};
  if (window.__chitaLoaded) return;
  window.__chitaLoaded = true;

  // ---------- 自己的 gtag：独立 dataLayer，不用店铺 GTM 的 window.gtag（GTM 删了也照常发；不会被 GTM 里的正式 ID 抢先或延迟） ----------
  // 放在首页判断之前：旧首页也 config，保证落地即生成 _ga_<ID> 会话 Cookie，像素的 page_view 能拼上同一会话
  var ga = null;

  // ---------- 关键事件直发（fetch keepalive），参数编码与 gtag 的 g/collect 请求一致 ----------
  var DIRECT = { add_to_cart: 1, remove_from_cart: 1, view_cart: 1, select_item: 1, select_promotion: 1, filter_apply: 1, sort_change: 1, bundle_item_select: 1,
    page_dwell: 1, web_vitals: 1 }; // 停留时长、INP/CLS 都在离开页面那一刻才报，同样直发
  var PAGE_LOAD_ID = String(Date.now()); // 对应 gtag 的 _p（同一页面加载的标识）
  var ITEM_KEYS = { item_id: 'id', item_name: 'nm', affiliation: 'af', coupon: 'cp', discount: 'ds', index: 'lp', item_brand: 'br',
    item_category: 'ca', item_category2: 'c2', item_category3: 'c3', item_category4: 'c4', item_category5: 'c5',
    item_list_id: 'li', item_list_name: 'ln', item_variant: 'va', location_id: 'lo', price: 'pr', quantity: 'qt',
    promotion_id: 'pi', promotion_name: 'pn', creative_name: 'cn', creative_slot: 'cs' };
  // v1.0.13：同名 cookie 可能有多个（不同域名写法 / 路径，比如 chitaliving.com 和 .chitaliving.com），原来只取第一个：
  // 取到旧的会话 cookie 就当成会话过期、退回 gtag 攒批，跳页即丢（Jennifer2 A-BUG8）。现在 _ga_ 会话 cookie 取最后活动时间最新的那个
  function cookie(n) {
    var re = new RegExp('(?:^|; )' + n.replace(/[.$]/g, '\\$&') + '=([^;]*)', 'g'), m, all = [];
    while ((m = re.exec(document.cookie))) all.push(decodeURIComponent(m[1]));
    if (all.length < 2) return all[0] || null;
    var ts = function (v) { var t = v.match(/\$t(\d+)/) || v.split('.').slice(5, 6); return Number(t && (t[1] || t[0])) || 0; };
    return all.sort(function (x, y) { return ts(y) - ts(x); })[0];
  }
  function gaIds() {
    var ga1 = (cookie('_ga') || '').split('.');           // GA1.1.<随机数>.<时间戳>
    var cid = ga1.length >= 4 ? ga1.slice(-2).join('.') : null;
    var gs = cookie('_ga_' + CTX.ga4_id.replace(/^G-/, '')), s = {};
    if (gs && gs.indexOf('GS2.') === 0) {                 // GS2.1.s<sid>$o<序号>$g<是否互动>$t<最后活动时间>$...
      gs.split('.').slice(2).join('.').split('$').forEach(function (kv) { if (kv) s[kv.charAt(0)] = kv.slice(1); });
    } else if (gs && gs.indexOf('GS1.') === 0) {          // GS1.1.<sid>.<序号>.<是否互动>.<最后活动时间>...
      var g1 = gs.split('.'); s = { s: g1[2], o: g1[3], g: g1[4], t: g1[5] };
    }
    if (!cid || !/^\d+$/.test(s.s || '') || !/^\d+$/.test(s.o || '')) return null;
    if (s.t && Date.now() / 1000 - Number(s.t) > 1800) return null; // 会话已超时：交给 gtag 开新会话
    return { cid: cid, sid: s.s, sct: s.o, seg: s.g === '1' ? '1' : '0' };
  }
  // 按字符（不是 UTF-16 单元）截 100：emoji 刚好在第 100 位时，截出的半个 emoji 会让 encodeURIComponent 报错，整条事件发不出去（J-T1）
  function cut(v, n) { return Array.from(String(v)).slice(0, n || 100).join(''); }
  function enc(v) { return cut(String(v).replace(/~/g, '-')); }
  // v1.0.15：直发补上 gtag 同款的浏览器设备提示（uamb / uam / uap / uapv / uafvl 等）。不带时 GA4 只能按 UA 猜设备，
  // 同一台安卓手机上 gtag 发的事件算「平板」、直发的算「手机」，按设备拆的漏斗会对不上（J2 10-30 Kevin 真机）
  var UACH = '';
  try {
    var uad = navigator.userAgentData;
    if (uad) {
      UACH = '&uamb=' + (uad.mobile ? 1 : 0) + '&uap=' + encodeURIComponent(uad.platform || '');
      if (uad.getHighEntropyValues) uad.getHighEntropyValues(['architecture', 'bitness', 'fullVersionList', 'model', 'platformVersion', 'wow64']).then(function (h) {
        var fvl = (h.fullVersionList || []).map(function (b) { return encodeURIComponent(b.brand) + ';' + encodeURIComponent(b.version); }).join('|');
        UACH = '&uaa=' + encodeURIComponent(h.architecture || '') + '&uab=' + encodeURIComponent(h.bitness || '') + '&uafvl=' + encodeURIComponent(fvl) +
          '&uamb=' + (h.mobile ? 1 : 0) + '&uam=' + encodeURIComponent(h.model || '') + '&uap=' + encodeURIComponent(h.platform || '') +
          '&uapv=' + encodeURIComponent(h.platformVersion || '') + '&uaw=' + (h.wow64 ? 1 : 0);
      }).catch(function () {});
    }
  } catch (e) {}
  function sendDirect(name, p) {
    try {
      var ids = gaIds();
      if (!ids || !window.fetch && !navigator.sendBeacon) return false;
      var q = ['v=2', 'tid=' + CTX.ga4_id, '_p=' + PAGE_LOAD_ID, 'cid=' + ids.cid, 'sid=' + ids.sid, 'sct=' + ids.sct, 'seg=' + ids.seg,
        'ul=' + (navigator.language || '').toLowerCase(), 'sr=' + screen.width + 'x' + screen.height,
        'dl=' + location.href, 'dt=' + document.title, 'en=' + name].map(function (kv) {
        var i = kv.indexOf('='); return kv.slice(0, i + 1) + encodeURIComponent(kv.slice(i + 1));
      });
      if (document.referrer) q.push('dr=' + encodeURIComponent(document.referrer));
      if (p.currency) q.push('cu=' + encodeURIComponent(p.currency));
      if (p.user_id) q.push('uid=' + encodeURIComponent(p.user_id));
      if (p.traffic_type) q.push('tt=' + encodeURIComponent(p.traffic_type));
      (p.items || []).slice(0, 200).forEach(function (it, i) {
        var f = [], k = 0;
        Object.keys(it).forEach(function (key) {
          var v = it[key]; if (v == null || v === '') return;
          if (ITEM_KEYS[key]) f.push(ITEM_KEYS[key] + enc(v));
          else { f.push('k' + k + enc(key)); f.push('v' + k + enc(v)); k++; }
        });
        q.push('pr' + (i + 1) + '=' + encodeURIComponent(f.join('~')));
      });
      Object.keys(p).forEach(function (key) {
        var v = p[key];
        if (v == null || v === '' || key === 'items' || key === 'currency' || key === 'user_id' || key === 'traffic_type') return;
        q.push((typeof v === 'number' ? 'epn.' : 'ep.') + key + '=' + encodeURIComponent(typeof v === 'number' ? v : enc(v)));
      });
      // 不带 _et：互动时长仍由 gtag 在它的下一条请求里统一上报，避免重复计算
      var url = 'https://www.google-analytics.com/g/collect?' + q.join('&') + UACH;
      // v1.0.12：优先 sendBeacon（iPhone/WebKit 上同一页连发的 fetch keepalive 会丢：燕妮 10-29 真机 加购→侧栏→再加购 4 条只到 1 条）；
      // beacon 排队满了返回 false 再退回 fetch keepalive
      if (navigator.sendBeacon && navigator.sendBeacon(url)) return true;
      if (window.fetch) { fetch(url, { method: 'POST', keepalive: true, mode: 'no-cors', credentials: 'include' }).catch(function () {}); return true; }
      return false;
    } catch (e) { return false; }
  }
  if (CTX.ga4_id) {
    try {
      window.chitaDataLayer = window.chitaDataLayer || [];
      ga = function () { window.chitaDataLayer.push(arguments); };
      ga('js', new Date());
      ga('config', CTX.ga4_id, { send_page_view: false }); // page_view 由像素发
      var gs = document.createElement('script');
      gs.async = true;
      gs.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(CTX.ga4_id) + '&l=chitaDataLayer';
      document.head.appendChild(gs);
    } catch (e) { ga = null; }
  }
  // 首页：只有改版后的首页（模块带 data-chita-module）才埋；脚本是 defer 加载，此时首页 HTML 已解析完
  if (CTX.page_type === 'index' && !document.querySelector('[data-chita-module]')) return;

  // ---------- 基础 ----------
  var DEBUG = (function () {
    try {
      var q = new URLSearchParams(location.search).get('chita_debug');
      if (q === '1') localStorage.setItem('chita_debug', '1');
      if (q === '0') localStorage.removeItem('chita_debug');
      return localStorage.getItem('chita_debug') === '1';
    } catch (e) { return false; }
  })();
  var CUR = CTX.currency || 'USD';
  function pageType() {
    var id = CTX.list && CTX.list.id;
    if (CTX.page_type === 'collection' && /seasonal-campaign-sale|black-friday|bfcm/i.test(id || '')) return 'bf';
    if (CTX.page_type === 'page' && /black-friday|bfcm/i.test((CTX.template_suffix || '') + ' ' + location.pathname)) return 'bf';   // v1.0.17：黑五落地页(页面模板 black-friday-*)
    if (CTX.page_type === 'collection' && /bundle/i.test(id || '')) return 'bundles';
    if (CTX.page_type === 'page' && /bundle/i.test(CTX.template_suffix || '')) return 'bundles';   // v1.0.18：组合购页(页面模板 bundles-*)
    if (CTX.page_type === 'index') return 'home';
    return CTX.page_type || CTX.template;
  }
  var device = window.innerWidth < 750 ? 'mob' : 'pc'; // 与主题断点一致，按视口宽度判断
  var common = {
    event_source: 'chita_theme',
    page_type: pageType(),
    device_type: device,
    customer_type: CTX.customer && CTX.customer.orders_count > 0 ? 'returning' : 'new'
  };
  if (CTX.customer) common.user_id = String(CTX.customer.id);
  if (DEBUG) { common.debug_mode = true; common.traffic_type = 'internal'; }

  window.chitaEvents = window.chitaEvents || [];
  var num = function (x) { return Math.round(Number(x || 0) * 100) / 100; };

  function track(name, params) {
    var p = Object.assign({}, common, params || {});
    var rec = { event: name, params: p, ts: Date.now() };
    window.chitaEvents.push(rec);
    if (ga) {
      if (!(DIRECT[name] && sendDirect(name, p))) { // 直发成功就不再交给 gtag，避免重复
        try { ga('event', name, Object.assign({ send_to: CTX.ga4_id }, p)); } catch (e) {}
      }
    }
    if (DEBUG) panel(rec);
  }
  window.chitaTrack = track;

  // ---------- 调试窗口 ----------
  var box;
  function panel(rec) {
    if (!document.body) return document.addEventListener('DOMContentLoaded', function () { panel(rec); });
    if (!box) {
      box = document.createElement('div');
      box.id = 'chita-debug';
      box.style.cssText = 'position:fixed;right:8px;bottom:8px;z-index:2147483647;width:300px;max-width:calc(100vw - 16px);max-height:45vh;overflow:auto;background:rgba(17,24,39,.92);color:#e5e7eb;font:12px/1.45 -apple-system,Menlo,monospace;border-radius:8px;padding:6px 8px;box-shadow:0 4px 16px rgba(0,0,0,.3)';
      box.innerHTML = '<div style="display:flex;justify-content:space-between;font-weight:600;color:#93c5fd"><span>CHITA 埋点调试</span><span id="chita-debug-x" style="cursor:pointer">－</span></div><div id="chita-debug-list"></div>';
      document.body.appendChild(box);
      box.querySelector('#chita-debug-x').onclick = function () {
        var l = box.querySelector('#chita-debug-list'); l.style.display = l.style.display === 'none' ? '' : 'none';
      };
    }
    var p = rec.params, extra = [];
    if (p.items) extra.push(p.items.length + ' 件' + (p.items[0] ? ' · ' + (p.items[0].item_name || '').slice(0, 22) : ''));
    if (p.value != null) extra.push('$' + p.value);
    ['quantity', 'cart_action', 'bundle_id', 'item_list_name', 'percent_scrolled', 'dwell_seconds', 'filter_type', 'filter_value', 'sort_by', 'item_variant', 'search_term', 'error_message'].forEach(function (k) { if (p[k] != null) extra.push(k + '=' + String(p[k]).slice(0, 30)); });
    var row = document.createElement('div');
    row.style.cssText = 'border-top:1px solid #374151;padding:3px 0';
    row.innerHTML = '<b style="color:#fde68a"></b> <span style="color:#9ca3af"></span><div></div>';
    row.children[0].textContent = rec.event;
    row.children[1].textContent = new Date(rec.ts).toLocaleTimeString();
    row.children[2].textContent = extra.join(' · ');
    var list = box.querySelector('#chita-debug-list');
    list.insertBefore(row, list.firstChild);
    while (list.children.length > 30) list.removeChild(list.lastChild);
  }

  // ---------- 商品工具 ----------
  function handleFromHref(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function itemFromCatalog(handle, index, listName) {
    var c = (CTX.catalog || {})[handle] || {};
    var it = { item_id: c.id ? String(c.id) : handle, item_name: c.title || handle, item_brand: c.vendor || undefined, item_category: c.type || undefined, price: c.price != null ? num(c.price) : undefined };
    if (index != null) it.index = index;
    if (listName) it.item_list_name = listName;
    return it;
  }

  // 优先读商品卡片上的 data-item-id / data-item-name（card-product.liquid 输出），没有再退回 catalog / handle
  function itemFromLink(a, h, ln) {
    var card = a.closest && a.closest('[data-chita-item]');
    var idxEl = a.closest && a.closest('[data-chita-index]');
    var it = itemFromCatalog(h, idxEl ? +idxEl.getAttribute('data-chita-index') : indexFor(ln, h), ln);
    if (card && card.getAttribute('data-item-id')) {
      it.item_id = card.getAttribute('data-item-id');
      if (card.getAttribute('data-item-name')) it.item_name = card.getAttribute('data-item-name');
      var pr = card.getAttribute('data-item-price'), br = card.getAttribute('data-item-brand'), ca = card.getAttribute('data-item-category');
      if (pr && !isNaN(+pr)) it.price = num(pr);
      if (br) it.item_brand = br;
      if (ca) it.item_category = ca;
    }
    return it;
  }

  function itemFromCartLine(l, qty) {
    return {
      item_id: String(l.product_id), item_variant_id: String(l.variant_id), item_variant: l.variant_title || undefined, item_sku: l.sku || undefined, item_name: l.product_title,
      item_category: l.product_type || undefined, item_brand: l.vendor || undefined,
      price: num(l.final_price / 100), quantity: qty,
      // 字典口径：price = 折后单价（含店铺自动折扣），discount = 每件优惠额
      discount: l.original_price > l.final_price ? num((l.original_price - l.final_price) / 100) : undefined
    };
  }

  // ---------- 列表曝光 / 点击（集合页、搜索、组合购、推荐位） ----------
  // 模块自带列表标记时优先用：data-chita-list = item_list_id，data-chita-list-name = item_list_name（首页标签页按标签各自一个列表）
  var listIdByName = {};
  function headingOf(sec) {
    var hd = sec && sec.querySelector('h1, h2, h3, .title, [class*="heading"]');
    return hd ? cut(hd.textContent.replace(/\s+/g, ' ').trim(), 60) : '';
  }
  function withHeading(base, sec) { var ht = headingOf(sec); return ht ? base + ' - ' + ht : base; }
  function listNameFor(a) {
    var mk = a.closest('[data-chita-list]');
    if (mk) {
      var lid = mk.getAttribute('data-chita-list'), lnm = mk.getAttribute('data-chita-list-name') || lid;
      listIdByName[lnm] = lid;
      return lnm;
    }
    var sec = a.closest('[id^="shopify-section-"]');
    var sid = sec ? sec.id.replace('shopify-section-', '') : '';
    if (/product-grid|main-collection|main-search/i.test(sid) && CTX.list) return CTX.list.name;
    if (/related|recommend/i.test(sid)) return 'Related products';
    if (CTX.page_type === 'product' && /(^|__)main$/.test(sid)) return 'Product page links';
    // v1.0.14：精选集合 / Shop the look 带上区块标题，多个同类区块不再撞成同一个列表（B-BUG4）
    if (/featured[-_]collection/i.test(sid)) return withHeading('Featured collection', sec);
    if (/shop[-_]the[-_]look/i.test(sid)) return withHeading('Shop the look', sec);
    if (/recent/i.test(sid)) return 'Recently viewed';
    if (/predictive|search/i.test(sid)) return 'Predictive search';
    if (CTX.list && sec && sec.querySelector('[id*="product-grid"],#ProductGridContainer,.product-grid')) return CTX.list.name;
    // v1.0.13：其他区块优先用区块标题（运营看得懂），没有标题才用区块代号（原来直接报 index_medium 这类内部代号——B-BUG1）
    var ht = headingOf(sec);
    if (ht) return ht;
    return sid ? sid.replace(/_[A-Za-z0-9]{6}$/, '').replace(/^template--\d+__/, '') : (CTX.list ? CTX.list.name : 'other');
  }
  function productLinks(root) {
    return Array.prototype.filter.call((root || document).querySelectorAll('a[href*="/products/"]'), function (a) {
      return !a.closest('header, footer, nav, .ch-header, #chita-debug, cart-drawer, .cart-drawer, cart-notification, [data-chita-promo]') && handleFromHref(a.getAttribute('href'));
    });
  }
  var seenImp = {}, impQueue = {}, impTimer = null, listIndex = {};
  function indexFor(listName, handle) {
    var li = listIndex[listName] || (listIndex[listName] = { n: 0, map: {} });
    if (!(handle in li.map)) li.map[handle] = ++li.n;
    return li.map[handle];
  }
  // 不发任何请求：曝光一次可能几十个商品，逐个查 /products/x.js 会把顾客 IP 打到限流。
  // 卡片/catalog 里没有数字 ID 的，item_id 先报 handle 并带 item_handle，入库时按 Shopify 商品表换成数字 ID
  function enrich(it) {
    if (!/^\d+$/.test(it.item_id)) it.item_handle = it.item_id;
    return Promise.resolve(it);
  }
  function listIdFor(ln) { return listIdByName[ln] || (CTX.list && ln === CTX.list.name ? CTX.list.id : String(ln).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '') || 'other'); } // 未标记的列表：ID 统一成小写下划线（原来直接用带空格的名字）
  function flushImpressions() {
    impTimer = null;
    var q = impQueue; impQueue = {};
    Object.keys(q).forEach(function (ln) {
      Promise.all(q[ln].map(enrich)).then(function (items) {
        for (var i = 0; i < items.length; i += 20) {
          track('view_item_list', { item_list_name: ln, item_list_id: listIdFor(ln), currency: CUR, items: items.slice(i, i + 20) });
        }
      });
    });
  }
  function recordImp(a) {
    io.unobserve(a);
    var h = handleFromHref(a.getAttribute('href')), ln = listNameFor(a);
    if (CTX.page_type === 'product' && CTX.product && h === CTX.product.handle) return;
    var key = ln + '|' + h;
    if (seenImp[key]) return;
    seenImp[key] = 1;
    (impQueue[ln] = impQueue[ln] || []).push(itemFromLink(a, h, ln));
    if (!impTimer) impTimer = setTimeout(flushImpressions, 1000);
  }
  // 带 data-chita-list 的列表（首页标签页 / 轮播）：在视口内且未被隐藏（aria-hidden / hidden / inert / visibility）才算曝光；
  // 隐藏的标签切出来时位置不变、不会再触发 IntersectionObserver，由下面的 MutationObserver 重新判断。未标记的列表行为不变
  var markedIn = new Map();
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var a = e.target;
      if (a.closest('[data-chita-list]')) {
        if (e.isIntersecting) markedIn.set(a, 1); else markedIn.delete(a);
        markedCheck(a);
        return;
      }
      if (e.isIntersecting) recordImp(a);
    });
  }, { threshold: 0.5 }) : null;
  var observed = new WeakSet();
  function scanLinks() {
    if (!io) return;
    productLinks().forEach(function (a) { if (!observed.has(a)) { observed.add(a); io.observe(a); } });
  }
  document.addEventListener('click', function (ev) {
    if (ev.target.closest && ev.target.closest('[data-chita-video-control]')) return;   // 视频播放 / 静音按钮只控制视频，不算点商品
    var a = ev.target.closest && ev.target.closest('a[href*="/products/"]');
    if (!a || productLinks(a.parentNode).indexOf(a) < 0) return;
    var h = handleFromHref(a.getAttribute('href')), ln = listNameFor(a);
    if (CTX.page_type === 'product' && CTX.product && h === CTX.product.handle) return;
    track('select_item', { item_list_name: ln, item_list_id: listIdFor(ln), currency: CUR, items: [itemFromLink(a, h, ln)] });
  }, true);

  // ---------- 筛选 / 排序 ----------
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.name) return;
    if (t.name === 'sort_by') return track('sort_change', { sort_by: t.value, item_list_name: CTX.list ? CTX.list.name : undefined });
    if (t.closest && t.closest('form[id^="FacetFiltersForm"], facet-filters-form') && /^filter\./.test(t.name)) {
      if (t.type === 'checkbox' && !t.checked) return;
      track('filter_apply', { filter_type: t.name.replace(/^filter\.(v|p)\./, ''), filter_value: t.value, item_list_name: CTX.list ? CTX.list.name : undefined });
    }
  }, true);

  // ---------- 商品详情：浏览 / 变体 ----------
  var P = CTX.product;
  function variantById(id) {
    if (!P) return null;
    for (var i = 0; i < P.variants.length; i++) if (String(P.variants[i].id) === String(id)) return P.variants[i];
    return null;
  }
  function pdpItem(v) {
    return { item_id: String(P.id), item_name: P.title, item_brand: P.vendor || undefined, item_category: P.type || undefined, item_variant_id: v ? String(v.id) : undefined, item_variant: v ? v.title : undefined, item_sku: v && v.sku || undefined, price: v ? num(v.price) : undefined, quantity: 1 };
  }
  var currentVariant = null;
  if (CTX.page_type === 'product' && P) {
    var urlV = new URLSearchParams(location.search).get('variant');
    currentVariant = variantById(urlV) || variantById(P.selected_variant_id) || P.variants[0];
    track('view_item', { currency: CUR, value: num(currentVariant && currentVariant.price), items: [pdpItem(currentVariant)] });
    var onVariant = function (id) {
      var v = variantById(id);
      if (!v || (currentVariant && String(v.id) === String(currentVariant.id))) return;
      currentVariant = v;
      track('variant_select', { item_id: String(P.id), item_variant: v.title, item_variant_id: String(v.id), value: num(v.price), currency: CUR });
    };
    ['pushState', 'replaceState'].forEach(function (fn) {
      var orig = history[fn];
      history[fn] = function (s, t, u) {
        var r = orig.apply(this, arguments);
        try { if (u) { var id = new URL(u, location.href).searchParams.get('variant'); if (id) onVariant(id); } } catch (e) {}
        return r;
      };
    });
    document.addEventListener('change', function (ev) {
      var f = ev.target && ev.target.closest && ev.target.closest('form[action*="/cart/add"]');
      if (!f) return;
      setTimeout(function () { var i = f.querySelector('[name="id"]'); if (i && i.value) onVariant(i.value); }, 50);
    }, true);
  }

  // ---------- 购物车：加购 / 改数量 / 删除（拦截购物车接口，前后对比，组合加购合并成 1 次） ----------
  var cartState = null;
  // 按变体合并（折扣重算后行 key 会变，按 key 比会把改数量误判成删+加）
  function lineMap(cart) {
    var m = {};
    (cart && cart.items || []).forEach(function (l) {
      var k = String(l.variant_id);
      if (m[k]) { m[k] = Object.assign({}, m[k], { quantity: m[k].quantity + l.quantity }); } else m[k] = l;
    });
    return m;
  }
  // 购物车快照存 localStorage（同站所有标签页共用、关掉标签也保留）：整页刷新（删除商品、非异步加购）后在下一页补发差异；换了购物车（下单后）不比
  // v1.0.13：原来存 sessionStorage，每个标签一份——B 标签删除后 A 刷新会按自己的旧快照再记一次删除（Jennifer2 A-BUG6）
  function saveCart(c) { try { localStorage.setItem('chita_cart', JSON.stringify({ token: c.token, t: Date.now(), items: (c.items || []).map(function (l) { return { variant_id: l.variant_id, product_id: l.product_id, product_title: l.product_title, product_type: l.product_type, vendor: l.vendor, final_price: l.final_price, original_price: l.original_price, variant_title: l.variant_title, sku: l.sku, quantity: l.quantity }; }) })); } catch (e) {} }
  // 只认 30 分钟内的快照（和 GA4 会话同长）：太旧的购物车可能被店铺自动改过（售罄下架等），再比会记出顾客没做过的删除
  function loadCart() { try { var c = JSON.parse(localStorage.getItem('chita_cart') || 'null'); return c && Date.now() - (c.t || 0) < 1800000 ? c : null; } catch (e) { return null; } }
  function getCart() {
    return origFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  var origFetch = window.fetch.bind(window);
  // v1.0.13：第一次取购物车也排进下面的处理队列（原来不排队：删除抢在它前面时手里没有「之前」，直接放弃，22:55 丢删除——Jennifer2 A-BUG3）；
  // 取失败时用快照当基准，后面的加购/删除照常比（原来一直为空，加购全丢——A-BUG4）
  var pending = getCart().then(function (c) {
    var prev = loadCart();
    cartState = c;
    if (prev && prev.token === c.token) emitDiff(prev, c, 'reload', {});
    saveCart(c);
  }, function () { cartState = loadCart(); }).catch(function () {});
  // 切回这个标签页时悄悄重取一次当基准，不发事件：别的标签页改过购物车，那边已经记过（A-BUG5）
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible' || !cartState) return;
    pending = pending.then(function () { return getCart().then(function (c) { cartState = c; saveCart(c); }); }).catch(function () {});
  });

  // 购物车页 / 侧边购物车里的 +/- 有的走 /cart/add：最近 3 秒内操作过购物车界面、且该商品原本就在购物车里，算改数量
  var lastCartUi = 0;
  var CART_UI = 'cart-items, cart-drawer, cart-drawer-items, cart-notification, quantity-input, .cart-drawer, [id*="CartDrawer"], [class*="cart-drawer"], [class*="CartDrawer"]';
  // v1.0.13：只算点在商品行 / 数量控件上；点侧栏的关闭 X、遮罩、标题不算（原来点 X 后 3 秒内在商品页加购，会被记成改数量——Jennifer2 A-BUG1）
  var CART_CLOSE = '[aria-label*="close" i], [class*="close"], [id*="Overlay"], [class*="overlay"], .drawer__header';
  ['click', 'change'].forEach(function (t) {
    document.addEventListener(t, function (ev) { try { if (ev.target.closest && ev.target.closest(CART_UI) && !ev.target.closest(CART_CLOSE)) lastCartUi = Date.now(); } catch (e) {} }, true);
  });
  function fromCartUi() { return Date.now() - lastCartUi < 3000; }

  function bundleIdOf(reqInfo) {
    var props = reqInfo.props || [];
    for (var i = 0; i < props.length; i++) {
      var p = props[i] || {};
      for (var k in p) if (/bundle/i.test(k) && p[k]) return String(p[k]);
    }
    return reqInfo.lineCount > 1 ? 'multi:' + reqInfo.lineCount : null;
  }
  function parseBody(body) {
    var info = { props: [], lineCount: 0, lines: [] };
    try {
      if (!body) return info;
      if (typeof body === 'string') {
        if (body.trim().charAt(0) === '{') {
          var j = JSON.parse(body);
          if (Array.isArray(j.items)) { info.lineCount = j.items.length; info.props = j.items.map(function (x) { return x.properties; }); info.lines = j.items.map(function (x) { return { id: String(x.id), q: +x.quantity || 1 }; }); }
          else { info.lineCount = 1; info.props = [j.properties]; if (j.id) info.lines = [{ id: String(j.id), q: +j.quantity || 1 }]; }
        } else {
          var sp = new URLSearchParams(body), pr = {};
          sp.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) pr[m[1]] = v; });
          info.lineCount = 1; info.props = [pr];
          if (sp.get('id')) info.lines = [{ id: sp.get('id'), q: +sp.get('quantity') || 1 }];
        }
      } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var pr2 = {}, ids = 0;
        body.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) pr2[m[1]] = v; if (k === 'id' || /^items\[\d+\]\[id\]$/.test(k)) ids++; });
        info.lineCount = ids || 1; info.props = [pr2];
        if (body.get('id')) info.lines = [{ id: String(body.get('id')), q: +body.get('quantity') || 1 }];
      }
    } catch (e) {}
    return info;
  }
  function emitDiff(before, after, kind, reqInfo) {
    var b = lineMap(before), a = lineMap(after), added = [], removed = [];
    Object.keys(a).forEach(function (k) {
      var d = a[k].quantity - (b[k] ? b[k].quantity : 0);
      if (d > 0) added.push(itemFromCartLine(a[k], d));
      if (d < 0) removed.push(itemFromCartLine(a[k], -d));
    });
    Object.keys(b).forEach(function (k) { if (!a[k]) removed.push(itemFromCartLine(b[k], b[k].quantity)); });
    var sum = function (arr) { return num(arr.reduce(function (s, x) { return s + x.price * x.quantity; }, 0)); };
    var qty = function (arr) { return arr.reduce(function (s, x) { return s + x.quantity; }, 0); };
    if (added.length) {
      var bid = kind === 'add' ? bundleIdOf(reqInfo) : null;
      if (!bid && kind === 'add') {
        var bp = (CTX.bundle_product_ids || []).map(String);
        var hit = added.filter(function (x) { return bp.indexOf(x.item_id) >= 0; })[0];
        if (hit) bid = hit.item_id;
      }
      // v1.0.20：组合购页弹窗加购（15 秒内有弹窗提交）记为组合加购
      if (kind === 'add' && common.page_type === 'bundles' && CTX.page_type === 'page' && Date.now() - lastBundleSubmit < 15000) bid = BUNDLE_ID;   // 组合购页(页面)加购统一用 page:页面网址最后一段，与商品行 _bundle 属性相同；组合购集合页(collection bundle-*)不在此列，照旧按请求里的选择码记
      var p = { currency: CUR, value: sum(added), quantity: qty(added), items: added, cart_action: bid ? 'bundle_add' : (added.some(function (x) { return !b[x.item_variant_id]; }) || (kind === 'add' && !fromCartUi()) ? 'add' : 'qty_change') };
      if (bid) {
        // 自选组合：bundle_id 统一用组合商品 ID（与 bundle_item_select 一致），选择码另放 bundle_selection
        if (/<>/.test(bid)) { p.bundle_selection = bid; var comp = bundleComponents(bid); if (comp) p.bundle_items = comp; bid = added[0].item_id; }
        p.bundle_id = bid;
      }
      track('add_to_cart', p);
    }
    if (removed.length) {
      track('remove_from_cart', { currency: CUR, value: sum(removed), quantity: qty(removed), items: removed, cart_action: Object.keys(b).some(function (k) { return !a[k]; }) ? 'remove' : 'qty_change' });
    }
  }
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  function onCartMutation(kind, reqInfo) {
    // 串行处理，避免并发改购物车时重复计数
    pending = pending.then(function () {
      var before = cartState || loadCart();
      // v1.0.13：加购直接按 /cart/add 的返回发（不再等再取一次 /cart.js）：加购后马上跳页 / 刷新 / 关页时，再取的那一步来不及，事件丢（A-BUG2、E6、E7）；
      // 发完立刻把快照同步加上，之后再悄悄取一次整车校准
      if (kind === 'add' && addFromResponse(before, reqInfo)) {
        // v1.0.16：校准只在取回的是真购物车、且已包含这次 /cart/add 返回的行（数量不少于返回值）时才覆盖快照；
        // 否则保留刚记的快照——取回的是加购之前的旧购物车（限流错误体、读到旧数据）时覆盖上去，下一页会把这次加购再补发一遍
        return getCart().then(function (c) {
          var m = c && Array.isArray(c.items) ? lineMap(c) : null;
          if (!m || reqInfo.respLines.some(function (l) { var x = m[String(l.variant_id)]; return !x || x.quantity < (+l.quantity || 1); })) return;
          cartState = c; saveCart(c);
        }, function () {});
      }
      // /cart/change、/cart/update、/cart/clear 返回的就是整个购物车，直接用，不再多请求一次 /cart.js
      var full = reqInfo.resp && reqInfo.resp.token && Array.isArray(reqInfo.resp.items) ? Promise.resolve(reqInfo.resp) : null;
      return (full || getCart()).then(function (after) {
        if (before) emitDiff(before, after, kind, reqInfo);
        cartState = after; saveCart(after);
      });
    }).catch(function () {});
  }
  // /cart.js 取不到（限流、网络）时：加购按请求里的数量 + /cart/add.js 返回的商品信息补发，并把本地购物车快照同步加上，避免下次重复计
  function addFromResponse(before, info) {
    var lines = (info.resp && (info.resp.items || (info.resp.variant_id ? [info.resp] : []))) || [];
    if (!lines.length) return false;
    info.respLines = lines;
    // v1.0.16：在所有标签页共用的快照上累加（本页内存里的购物车可能是别的标签页 / 返回缓存页留下的旧状态，按它存会把别处已记的行抹掉）
    var shared = loadCart();
    if (shared && (!before || shared.token === before.token)) before = shared;
    var q = {};
    (info.lines || []).forEach(function (x) { q[x.id] = (q[x.id] || 0) + x.q; });
    var after = { token: before && before.token, items: (before && before.items || []).slice() };
    lines.forEach(function (l) { after.items.push(Object.assign({}, l, { quantity: q[String(l.variant_id)] || 1 })); });
    emitDiff(before || { items: [] }, after, 'add', info);
    cartState = after; saveCart(after);
    return true;
  }
  // 组合购自选页：_bundle_selection = 子商品哈希「a <> b」，对应页面上 byob-variant[hash]
  function bundleComponents(bid) {
    var out = [];
    String(bid).split(/\s*<>\s*/).forEach(function (h) {
      var v = h && document.querySelector('byob-variant[hash="' + h.replace(/"/g, '') + '"]');
      if (v) out.push(v.getAttribute('variant-id'));
    });
    return out.length ? out.join(',') : null;
  }
  function kindOf(url) { var m = String(url).match(CART_RE); return m ? (m[1] === 'add' ? 'add' : 'change') : null; }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input || ''); // URL 对象没有 .url（A-BUG7）
    var kind = kindOf(url);
    var p = origFetch.apply(this, arguments);
    if (kind) {
      var info = parseBody(init && init.body);
      p.then(function (r) {
        if (!r || !r.ok) return;
        r.clone().json().then(function (j) { info.resp = j; }, function () {}).then(function () { onCartMutation(kind, info); });
      }).catch(function () {});
    }
    return p;
  };
  var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__chitaKind = kindOf(u); return XO.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__chitaKind) {
      var x = this, kind = this.__chitaKind, info = parseBody(body);
      x.addEventListener('load', function () {
        if (x.status < 200 || x.status >= 300) return;
        try { info.resp = JSON.parse(x.responseText); } catch (e) {}
        onCartMutation(kind, info);
      });
    }
    return XS.apply(this, arguments);
  };

  // ---------- 查看购物车（购物车页 + 侧边购物车打开） ----------
  function viewCart(where) {
    var go = function (c) {
      track('view_cart', { cart_location: where, currency: CUR, value: num(c.total_price / 100), items: (c.items || []).map(function (l) { return itemFromCartLine(l, l.quantity); }) });
    };
    (cartState ? Promise.resolve(cartState) : getCart()).then(go).catch(function () {});
  }
  if (CTX.page_type === 'cart') viewCart('cart_page');
  function watchDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d || d.__chitaWatch) return;
    d.__chitaWatch = 1;
    var open = d.classList.contains('active');
    new MutationObserver(function () {
      var now = d.classList.contains('active');
      if (now && !open) setTimeout(function () { pending.then(function () { viewCart('drawer'); }); }, 300);
      open = now;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  // ---------- 搜索结果 ----------
  if (CTX.page_type === 'search' && CTX.search_term) track('view_search_results', { search_term: CTX.search_term, results_count: CTX.search_results });

  // ---------- 滚动深度（每页每档 1 次） ----------
  var marks = [25, 50, 75, 90], hit = {}, scrollOn = /^(home|collection|product|bf|bundles)$/.test(common.page_type);
  function onScroll() {
    if (!scrollOn) return;
    var h = document.documentElement, total = h.scrollHeight - h.clientHeight;
    if (total <= 0) return;
    var pct = (h.scrollTop || document.body.scrollTop) / total * 100;
    marks.forEach(function (m) { if (pct >= m && !hit[m]) { hit[m] = 1; track('scroll_depth', { percent_scrolled: m }); } });
  }
  window.addEventListener('scroll', function () { if (!onScroll.t) onScroll.t = setTimeout(function () { onScroll.t = null; onScroll(); }, 250); }, { passive: true });

  // ---------- 停留时长（只算页面在前台的时间；v1.0.15：每次切走 / 离开都补报这一段，分析时按页面加总） ----------
  var activeMs = 0, sentMs = 0, since = document.visibilityState === 'visible' ? Date.now() : null;
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { if (since) { activeMs += Date.now() - since; since = null; } sendDwell(); }
    else since = Date.now();
  });
  window.addEventListener('pagehide', function () { if (since) { activeMs += Date.now() - since; since = null; } sendDwell(); });
  function sendDwell() {
    if (CTX.page_type !== 'product') return; // 字典：只在详情页报
    var ms = activeMs - sentMs;
    if (ms < 1000) return; // 不足 1 秒的这段不报、留到下一段累计（hidden 后紧跟 pagehide 也不会重复）；先按毫秒判断，0.5～0.99 秒不会被四舍五入成 1（J2 10-30 回归）
    var sec = Math.round(ms / 1000);
    sentMs += sec * 1000;
    var p = { dwell_seconds: sec };
    if (P) { p.item_id = String(P.id); p.item_name = P.title; }
    track('page_dwell', p);
  }

  // ---------- JS 报错（每页最多 5 条） ----------
  var errN = 0, errSeen = {};
  window.addEventListener('error', function (e) {
    if (errN >= 5 || !e || !e.message) return;
    var ek = e.message + '|' + e.filename + '|' + e.lineno;
    if (errSeen[ek]) return;
    errSeen[ek] = 1; errN++;
    track('js_error', { error_message: cut(e.message), error_source: cut(String(e.filename || '').replace(/^https?:\/\/[^/]+/, '')), line: e.lineno });
  });

  window.addEventListener('unhandledrejection', function (e) {
    var r = e && e.reason, msg = cut(r && (r.message || r) || 'unhandledrejection');
    if (errN >= 5 || errSeen[msg]) return;
    errSeen[msg] = 1; errN++;
    track('js_error', { error_message: msg, error_source: 'promise' });
  });

  // ---------- 黑五页活动位：曝光 / 点击（view_promotion / select_promotion） ----------
  // 不改各区块代码：黑五页上除商品主列表、页头页脚、最近浏览外的每个区块里，每个「带图片或按钮的链接」算一个活动位
  // creative_slot = 区块名#序号，promotion_name = 区块标题（取不到用区块名），链接是商品时带 item_id
  if (common.page_type === 'bf') {
    var promoSeen = {}, promoTimers = new WeakMap();
    var promoIo = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var el = en.target, d = el.__chitaPromo;
        if (!d || promoSeen[d.creative_slot]) return;
        if (en.isIntersecting) promoTimers.set(el, setTimeout(function () { promoSeen[d.creative_slot] = 1; promoIo.unobserve(el); track('view_promotion', d); }, 1000));
        else clearTimeout(promoTimers.get(el));
      });
    }, { threshold: 0.5 }) : null;
    var SKIP = /header|footer|announcement|product-grid|recently_viewed/i;
    var promoData = function (a, key, idx, title) {
      var h = handleFromHref(a.getAttribute('href')), card = a.closest('[data-chita-item]');
      var d = { promotion_id: key, promotion_name: title, creative_slot: key + '#' + idx, creative_name: (a.textContent || a.getAttribute('aria-label') || '').trim().replace(/\s+/g, ' ').replace(/\s+(From|Sale)?\s*\$[\d,.]+.*$/, '').slice(0, 60) || undefined, link_url: (a.getAttribute('href') || '').split('?')[0].slice(0, 120) };
      if (card && card.getAttribute('data-item-id')) d.item_id = card.getAttribute('data-item-id');
      else if (h) { var c = (CTX.catalog || {})[h]; d.item_id = c && c.id ? String(c.id) : h; }
      return d;
    };
    var scanPromos = function () {
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function (sec) {
        var key = sec.id.replace(/^shopify-section-(template|sections)--\d+__/, '');
        if (SKIP.test(key)) return;
        var hd = sec.querySelector('h1, h2, h3');
        var title = hd ? hd.textContent.trim().replace(/\s+/g, ' ').slice(0, 60) : key;
        var idx = 0, hrefs = {};
        sec.querySelectorAll('a[href]').forEach(function (a) {
          if (a.__chitaPromo !== undefined) return;
          if (a.closest('[data-chita-promo]')) { a.__chitaPromo = null; return; }   // 已有标记的位置走标记式活动位，避免重复
          if (a.closest('[data-chita-list]')) { a.__chitaPromo = null; return; }    // 11-03（Nora 定 A）：商品列表里的卡片只按列表报（view_item_list / select_item），不再算活动位，同一次点击只记一次
          var href = (a.getAttribute('href') || '').split('?')[0];
          if (!href || href === '#' || /^javascript:/i.test(href) || !(a.querySelector('img, picture, video') || /button|btn/i.test(a.className))) { a.__chitaPromo = null; return; }
          if (hrefs[href]) { a.__chitaPromo = hrefs[href]; return; }
          var d = a.__chitaPromo = hrefs[href] = promoData(a, key, ++idx, title);
          if (d.item_id && !/^\d+$/.test(d.item_id)) d.item_handle = d.item_id;
          if (promoIo) promoIo.observe(a);
        });
      });
    };
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href]');
      if (a && a.__chitaPromo) track('select_promotion', a.__chitaPromo);
    }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanPromos); else scanPromos();
    setTimeout(scanPromos, 3000);   // 延迟加载的区块（PageFly / 应用）再扫一次
  }

  // ---------- 标记式活动位（首页等）：data-chita-promo（全站通用，黑五页的自动识别不受影响） ----------
  // 元素：data-chita-promo = promotion_id / creative_slot（如 home_hero_1），data-chita-creative = creative_name（后台标题），
  //       可选 data-item-id（推荐位是商品时）；模块：data-chita-module = 模块 ID，data-chita-module-name = promotion_name
  // 曝光：可见 ≥50% 且持续 ≥1 秒，每个位置每次页面浏览 1 次；轮播里未显示的那几张（aria-hidden / hidden / inert / 不可见）不算，
  //       切换到它时重新判断
  var mPromoSeen = {}, mPromoIn = new WeakMap(), mPromoTimer = new WeakMap(), mPromoObserved = new WeakSet();
  function mPromoData(el) {
    var mod = el.closest('[data-chita-module]'), a = el.matches('a[href]') ? el : el.querySelector('a[href]');
    var d = { promotion_id: el.getAttribute('data-chita-promo'), creative_slot: el.getAttribute('data-chita-promo'),
      promotion_name: mod ? (mod.getAttribute('data-chita-module-name') || mod.getAttribute('data-chita-module')) : undefined,
      creative_name: cut(el.getAttribute('data-chita-creative') || '') || undefined,
      link_url: a ? (a.getAttribute('href') || '').split('?')[0].slice(0, 120) : undefined };
    var iid = el.getAttribute('data-item-id') || (a && handleFromHref(a.getAttribute('href')));
    if (iid) { d.item_id = String(iid); if (!/^\d+$/.test(d.item_id)) d.item_handle = d.item_id; }
    return d;
  }
  function mPromoVisible(el) {
    if (el.closest('[aria-hidden="true"], [hidden], [inert]')) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && +cs.opacity > 0.1;
  }
  // 列表卡片：可见要连续 0.5 秒才记（不可见就清计时）。markedIn = 在视口内、还没记过的卡
  var markedTimer = new WeakMap();
  function markedCheck(a) {
    if (!markedIn.has(a) || !mPromoVisible(a)) { clearTimeout(markedTimer.get(a)); markedTimer.delete(a); return; }
    if (markedTimer.get(a)) return;
    markedTimer.set(a, setTimeout(function () {
      markedTimer.delete(a);
      if (markedIn.has(a) && mPromoVisible(a)) { markedIn.delete(a); recordImp(a); }
    }, 500));
  }
  // 脚本加载前已经显示的时间（只用于第一次判断）：页面没滚动过、所在轮播还没切换过（.is-run），就当作从首次绘制起一直可见
  var mPromoBoot = {}, fcp = null;
  try { fcp = performance.getEntriesByName('first-contentful-paint')[0]; } catch (e) {}
  // v1.0.13：轮播自己记的显示时长（data-chita-shown-ms 累计 + 当前张 now − data-chita-shown-at，只在 Hero 过半在屏、标签页可见时计时）。
  // 脚本晚启动时轮播可能已经切过，原来的「按首次绘制起算」用不上，第 1 张的曝光就丢了（首页同学 G-BUG4）
  function mPromoShown(el) {
    var ms = +el.getAttribute('data-chita-shown-ms') || 0, at = el.getAttribute('data-chita-shown-at');
    if (at !== null && at !== '') ms += Math.max(0, performance.now() - +at);
    return ms;
  }
  function mPromoShownBackfill() {
    document.querySelectorAll('[data-chita-shown-ms], [data-chita-shown-at]').forEach(function (el) {
      var id = el.getAttribute('data-chita-promo');
      if (!id || mPromoSeen[id] || mPromoShown(el) < 1000) return;
      mPromoSeen[id] = 1; mPromoBoot[id] = 1;
      track('view_promotion', mPromoData(el));
    });
  }
  function mPromoCredit(el) {
    if (mPromoBoot[el.getAttribute('data-chita-promo')]) return 0;
    if (el.hasAttribute('data-chita-shown-ms') || el.hasAttribute('data-chita-shown-at')) return mPromoShown(el);
    if (!fcp) return 0;
    if (window.scrollY > 0 || el.closest('.is-run')) return 0;
    return Math.max(0, performance.now() - fcp.startTime);
  }
  function mPromoCheck(el) {
    var id = el.getAttribute('data-chita-promo');
    if (!id || mPromoSeen[id]) return;
    // 不可见才清计时；已在计时且仍可见就不重置（首页持续动画每秒上百次 class/style 变化，每次重置会让 1 秒永远等不满）
    if (!mPromoIn.get(el) || !mPromoVisible(el)) { if (mPromoIn.has(el)) mPromoBoot[id] = 1; clearTimeout(mPromoTimer.get(el)); mPromoTimer.delete(el); return; }
    if (mPromoTimer.get(el)) return;
    var credit = mPromoCredit(el); mPromoBoot[id] = 1;
    mPromoTimer.set(el, setTimeout(function () {
      mPromoTimer.delete(el);
      if (mPromoSeen[id] || !mPromoIn.get(el) || !mPromoVisible(el)) return;
      mPromoSeen[id] = 1;
      track('view_promotion', mPromoData(el));
    }, Math.max(0, 1000 - credit)));
  }
  var mPromoIo = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (en) { mPromoIn.set(en.target, en.isIntersecting); mPromoCheck(en.target); });
  }, { threshold: 0.5 }) : null;
  function scanMarkedPromos() {
    if (!mPromoIo) return;
    document.querySelectorAll('[data-chita-promo]').forEach(function (el) {
      if (!mPromoObserved.has(el)) { mPromoObserved.add(el); mPromoIo.observe(el); }
    });
  }
  // 轮播切换只改属性 / 样式、不改位置时，IntersectionObserver 不会再回调，靠这里重新判断
  if ('MutationObserver' in window) {
    var mpt = null;
    new MutationObserver(function () {
      if (mpt) return;
      mpt = setTimeout(function () {
        mpt = null;
        document.querySelectorAll('[data-chita-promo]').forEach(mPromoCheck);
        markedIn.forEach(function (v, a) { markedCheck(a); });
      }, 200);
    }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['aria-hidden', 'hidden', 'inert', 'class', 'style'] });
  }
  // CSS 淡入动画 / 过渡只改计算样式、不触发上面的 MutationObserver：动画结束时重新判断一次（只看已在视口内的）
  function mRecheck() {
    document.querySelectorAll('[data-chita-promo]').forEach(function (el) { if (mPromoIn.get(el)) mPromoCheck(el); });
    markedIn.forEach(function (v, a) { markedCheck(a); });
  }
  var mrt = null;
  function mRecheckSoon() { if (!mrt) mrt = setTimeout(function () { mrt = null; mRecheck(); }, 100); }
  document.addEventListener('animationend', mRecheckSoon, true);
  // 首页卡片的淡入（首屏出现、切标签）用 Web Animations（element.animate），结束时没有 animationend / transitionend，也不改属性：
  // 只要还有「在视口内、但还没显示出来」的卡，就每 0.7 秒再判断一次（没有就不做事）
  setInterval(function () { if (markedIn.size) markedIn.forEach(function (v, a) { markedCheck(a); }); }, 700);
  document.addEventListener('transitionend', mRecheckSoon, true);
  document.addEventListener('click', function (ev) {
    if (ev.target.closest && ev.target.closest('[data-chita-video-control]')) return;
    var el = ev.target.closest && ev.target.closest('[data-chita-promo]');
    if (!el) return;
    // 容器本身不是链接时（如 Chosen 卡片），只有点在里面的链接上（图片、Learn More）才算；点标题、描述文字、按钮不算
    if (!el.matches('a[href]')) { var a = ev.target.closest('a[href]'); if (!a || !el.contains(a)) return; }
    track('select_promotion', mPromoData(el));
  }, true);

  // ---------- 卡片视频（首页 Live With）：<video data-chita-video="live_with_标签序号_卡片序号"> ----------
  // 每个视频每次页面浏览：video_start 自动播放最多 1 次（video_trigger=auto）+ 顾客主动最多 1 次（click / unmute，先到先记）；
  //   video_progress（50%）、video_complete 各最多 1 次，循环播放不重复；静音切换本身不发播放事件
  // click = 播放前 1 秒内点在这个视频本身或它的播放 / 静音按钮上；点页面别处（切标签等）不算
  var vSent = {}, vLastTap = new WeakMap();
  function vEl(t) {
    if (!t || !t.closest) return null;
    var v = t.closest('video[data-chita-video]');
    if (v) return v;
    var c = t.closest('[data-chita-video-control]'), card = c && (c.closest('[data-chita-item]') || c.parentNode);
    return card ? card.querySelector('video[data-chita-video]') : null;
  }
  function vData(v) {
    var card = v.closest('[data-chita-item]'), d = { video_id: v.getAttribute('data-chita-video'),
      video_title: cut(v.getAttribute('title') || v.getAttribute('aria-label') || '') || undefined,
      video_duration: isFinite(v.duration) ? Math.round(v.duration) : undefined };
    if (card) {
      d.item_id = card.getAttribute('data-item-id') || undefined;
      d.index = +card.getAttribute('data-chita-index') || undefined;
      var ln = card.closest('[data-chita-list]');
      d.item_list_name = ln ? ln.getAttribute('data-chita-list') : undefined;
    }
    return d;
  }
  function vOnce(v, key, name, extra) {
    var k = v.getAttribute('data-chita-video') + '|' + key;
    if (vSent[k]) return;
    vSent[k] = 1;
    var d = vData(v);
    for (var x in extra) d[x] = extra[x];
    track(name, d);
  }
  ['pointerdown', 'click'].forEach(function (t) {
    document.addEventListener(t, function (ev) { var v = vEl(ev.target); if (v) vLastTap.set(v, Date.now()); }, true);
  });
  document.addEventListener('play', function (ev) {
    var v = ev.target;
    if (!v.matches || !v.matches('video[data-chita-video]')) return;
    if (Date.now() - (vLastTap.get(v) || 0) <= 1000) vOnce(v, 'user', 'video_start', { video_trigger: 'click' });
    else vOnce(v, 'auto', 'video_start', { video_trigger: 'auto' });
  }, true);
  document.addEventListener('volumechange', function (ev) {
    var v = ev.target;
    if (!v.matches || !v.matches('video[data-chita-video]') || v.muted || v.paused) return;
    if (Date.now() - (vLastTap.get(v) || 0) <= 1000) vOnce(v, 'user', 'video_start', { video_trigger: 'unmute' });
  }, true);
  document.addEventListener('timeupdate', function (ev) {
    var v = ev.target;
    if (!v.matches || !v.matches('video[data-chita-video]') || !(v.duration > 0)) return;
    if (v.currentTime / v.duration >= 0.5) vOnce(v, 'p50', 'video_progress', { video_percent: 50 });
    // 循环播放（loop）不触发 ended：最后 0.5 秒内算播完
    if (v.duration - v.currentTime <= 0.5) vOnce(v, 'end', 'video_complete', {});
  }, true);
  document.addEventListener('ended', function (ev) {
    var v = ev.target;
    if (v.matches && v.matches('video[data-chita-video]')) vOnce(v, 'end', 'video_complete', {});
  }, true);

  // ---------- 组合购自选页（Simple Bundles）：选子商品 bundle_item_select ----------
  // 子商品加进「Your bundle」不是加购物车；凑够件数点 Add bundle to cart 才是 1 次 add_to_cart（cart_action=bundle_add）
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('button.byob-cta');
    if (!btn || !/^\s*add\s*$/i.test(btn.textContent)) return;
    var v = null, qty = 1, dlg = btn.closest('dialog.byob-options-modal');
    if (dlg) {
      var title = dlg.getAttribute('aria-label') || '', opts = [];
      dlg.querySelectorAll('select.byob-bundle__product-variant-select').forEach(function (s) { opts.push(s.value); });
      var q = dlg.querySelector('input[type="number"], input[name*="qty"], input[name*="quantity"]');
      if (q && +q.value > 0) qty = +q.value;
      v = Array.prototype.filter.call(document.querySelectorAll('byob-variant'), function (x) {
        return x.getAttribute('product-title') === title && (!opts.length || x.getAttribute('option-values') === opts.join('<>'));
      })[0];
    } else {
      var bp = btn.closest('byob-product, byob-product-picker-card');
      v = bp && bp.querySelector('byob-variant');
    }
    if (!v) return;
    var prod = v.closest('byob-product');
    var it = { item_id: prod ? prod.getAttribute('product-id') : undefined, item_variant_id: v.getAttribute('variant-id'), item_name: v.getAttribute('product-title'), item_variant: (v.getAttribute('option-values') || '').split('<>').join(' / ') || undefined, price: num((+v.getAttribute('price-cents') || 0) / 100), quantity: qty };
    track('bundle_item_select', { bundle_id: P ? String(P.id) : undefined, currency: CUR, value: num(it.price * qty), items: [it] });
  }, true);

  // ---------- v1.0.18 组合购页（页面模板 bundles-*，自建小购物车 CustomCart）----------
  // 这个页面选的商品先进页面自己的小购物车，点结账直接跳 /cart/<变体:数量>，不经过 /cart/add：
  // 选一件 = bundle_item_select；点结账 = 1 次 add_to_cart（cart_action=bundle_add，带全部所选商品）
  function hookCustomCart() {
    var cc = window.CustomCart;
    if (!cc || cc.__chita || typeof cc.addItem !== 'function') return;
    cc.__chita = true;
    var orig = cc.addItem;
    cc.addItem = function (variantId, quantity, meta) {
      var r = orig.apply(this, arguments);
      try {
        var m = meta || {}, q = quantity || 1;
        var it = { item_id: BUNDLE_PID[String(variantId)], item_variant_id: String(variantId), item_name: m.title || undefined, price: num((m.price || 0) / 100), quantity: q };
        track('bundle_item_select', { bundle_id: BUNDLE_ID, currency: CUR, value: num(it.price * q), items: [it] });
      } catch (e) {}
      return r;
    };
  }
  var BUNDLE_ID = 'page:' + location.pathname.split('/').pop();   // v1.0.21：取页面网址最后一段(page handle)，与商品行 _bundle 属性一致（Nora 11-02）
  // 小购物车只存变体 ID：选商品时从弹窗 id(QuickAdd-<商品ID>) 记下 变体→商品 ID，加购事件带 item_id（v1.0.19）
  var BUNDLE_PID = {}, lastBundleCheckout = 0, lastBundleSubmit = 0;
  if (common.page_type === 'bundles') {
    hookCustomCart();
    document.addEventListener('submit', function (ev) {
      try {
        var f = ev.target, md = f && f.closest && f.closest('quick-add-modal'), m = md && /^QuickAdd-(\d+)$/.exec(md.id || '');
        var vid = f && f.querySelector && f.querySelector('[name="id"]');
        if (m && vid && vid.value) BUNDLE_PID[String(vid.value)] = m[1];
        if (md) lastBundleSubmit = Date.now();
      } catch (e) {}
    }, true);
    document.addEventListener('DOMContentLoaded', hookCustomCart);
    window.addEventListener('load', hookCustomCart);
    document.addEventListener('click', function (ev) {
      hookCustomCart();
      var btn = ev.target.closest && ev.target.closest('custom-cart-popup .ccp-checkout');
      var cc = window.CustomCart;
      // 不看 aria-disabled：从结账页按返回键回来(浏览器缓存页)按钮还停在 disabled，但页面照样跳结账；2 秒内重复点只记 1 次
      if (!btn || !cc || !cc.items || !cc.items.length || Date.now() - lastBundleCheckout < 2000) return;
      lastBundleCheckout = Date.now();
      var items = cc.items.map(function (i) { return { item_id: BUNDLE_PID[String(i.variantId)], item_variant_id: String(i.variantId), item_name: i.title || undefined, price: num((i.price || 0) / 100), quantity: i.quantity }; });
      var tv = 0, tq = 0; items.forEach(function (x) { tv += x.price * x.quantity; tq += x.quantity; });
      track('add_to_cart', { currency: CUR, value: num(tv), quantity: tq, items: items, cart_action: 'bundle_add', bundle_id: BUNDLE_ID });
    }, true);
  }

  // ---------- Web Vitals（LCP / INP / CLS，抽样 10% 会话；调试模式全采） ----------
  try {
    var vs = sessionStorage.getItem('chita_vs');
    if (vs === null) { vs = Math.random() < 0.1 ? '1' : '0'; sessionStorage.setItem('chita_vs', vs); }
    if ((vs === '1' || DEBUG) && CTX.web_vitals_src) {
      var wv = document.createElement('script');
      wv.src = CTX.web_vitals_src; wv.async = true;
      wv.onload = function () {
        ['onLCP', 'onINP', 'onCLS'].forEach(function (fn) {
          window.webVitals[fn](function (m) { track('web_vitals', { metric_name: m.name, metric_value: Math.round(m.value * 1000) / 1000, metric_rating: m.rating }); });
        });
      };
      document.head.appendChild(wv);
    }
  } catch (e) {}

  // ---------- 启动 ----------
  function boot() { scanLinks(); mPromoShownBackfill(); scanMarkedPromos(); watchDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  if ('MutationObserver' in window) {
    var mt = null;
    new MutationObserver(function () { if (!mt) mt = setTimeout(function () { mt = null; scanLinks(); scanMarkedPromos(); watchDrawer(); }, 500); }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

